import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Lang from '../Lang';
Vue.use(VueI18n);
// @ts-ignore
const initialPage = JSON.parse(window.app.dataset.page);
const i18n = new VueI18n({
    locale: initialPage.props.locale,
    fallbackLocale: initialPage.props.fallbackLocale,
    formatFallbackMessages: true,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    messages: {
        en: Lang.en,
        de: Lang.de,
    },
});
export default i18n;
